module.exports = __webpack_public_path__ + "media/images/company/cp18-bc6ef4093c6f2ecd02665d2296c424ac.png";